import Cookies from './Cookies';

export default class AlertBanner {
  constructor() {
    this.banner = document.querySelector('.js-alert-banner');
    this.banner_content = this.banner.querySelector('.js-alert-content').innerText.replace(/\s/g, "");
    this.banner_close = this.banner.querySelector('.js-alert-close');
    this.cookie_name = 'js-alert-banner-closed';
    this.cookies = new Cookies();
    this.cookie_value = this.cookies.getCookie(this.cookie_name);
    this.site_container =  document.querySelector('.js-site-body');
    this.weather_widget = document.querySelector('.js-weather-widget');
    this.header_main = document.querySelector('.js-header-main');

    if(!this.hasClosed() || this.hasChanged()) {
      this.openBanner();
    }

    if(this.banner_close !== null) {
      this.banner_close.addEventListener('click', (event) => {
        this.cookies.setCookie(this.cookie_name, this.banner_content, 100);
        this.closeBanner();
      });
    }

  }

  hasChanged() {
    if(this.cookie_value == this.banner_content) {
      return false;
    }

    if(this.hasClosed()) {
      this.clearCookie();
    }

    return true;
  }

  hasClosed() {
    if(this.cookie_value == '') {
      return false;
    }

    return true;
  }

  clearCookie() {
    this.cookies.clearCookie(this.cookie_name);
  }

  closeBanner() {
    this.banner.classList.remove('--active');
    this.weather_widget.classList.remove('--alert-open');
    this.header_main.classList.remove('--alert-open');
    this.site_container.style.paddingTop = '0';
  }

  openBanner() {
    this.banner.classList.add('--active');
    this.weather_widget.classList.add('--alert-open');
    this.header_main.classList.add('--alert-open');
    this.resizeBanner();
  }

  resizeBanner() {
    // calculate height of banner and offset entire site by that amount
    const bannerHeight = this.banner.offsetHeight;
    this.site_container.style.paddingTop = `${bannerHeight}px`;
  }
}

